import * as React from "react"
import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";
import { Box } from "@mui/material";
import { AutocompleteSeeker } from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants"
import { favFilterSelected } from "@signals";
import { setCommonFilters, resetCommonFilters } from "@signals";
import { favFiltersData } from "../Modal/FavFilter/@signals";
import useFavFilterModal from "../Modal/FavFilter/@hooks/useFavFilterModal";
import { CommonFiltersFavouriteFiltersModal } from "../Modal";


export default function CommonFiltersFavFilter({ ...props }) {
    const { getFavouriteFilters } = useFavFilterModal()
    const placeholder = useSignal("Saved Filters")
    const disabled = useSignal(false)

    useEffect(() => {
        getFavouriteFilters(props?.dashboardKey, true)
    }, [])

    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CommonFiltersFavouriteFiltersModal dashboardKey={props?.dashboardKey} />
        <AutocompleteSeeker
            options={favFiltersData.value}
            label="Your Favourite Filters"
            value={favFilterSelected.value}
            placeholder={placeholder.value}
            disabled={disabled.value}
            onChange={e => {
                favFilterSelected.value = e.target.value
                if (!e.target.value)
                    resetCommonFilters()
                setCommonFilters(e.target.value)
            }}
            {...props}
        />
    </Box>
}